import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import RightTimeApi from "@/API";
import Enums from "@/enums";

export default function AdminUsersTable(props) {
  const canEditUsers = props.adminPerms?.includes(Enums.ROLE_PERMS.EditUser)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  async function toggleAdminUserAsync(e) {
    if (!canEditUsers) return;
    const userId = parseInt(e.currentTarget.getAttribute("data-userid"));
    var data = {
      userId: userId,
      companyId: props.userData.companyId
    };
    var resp = await RightTimeApi.putAsync("toggleAdminUserCompanyAccess", data);
    if (resp.ok) {
      props.updateData();
    }
  }

  return (
    <div className="tableWrapper factTable horizontal">
      <table className="formFields">
        <caption data-help-id="adminUsersTable">
          <span className="title">Admin Users</span>
        </caption>
        <thead>
          <tr>
            <th>User</th>
            <th>Access</th>
          </tr>
        </thead>
        <tbody>
          {props.userData.adminUsers.map((user) => (
            <tr key={user.id}>
              <td>{user.firstName} {user.lastName}</td>
              <td
                onClick={(e) => {
                  if (canEditUsers) toggleAdminUserAsync(e);
                }}
                data-userid={user.id}
                className="actions"
              >
                {user.companyIds.includes(props.userData.companyId) ?
                  <MdCheckBox className={`checkbox checked actionIcon${canEditUsers ? "" : " disabled"}`} /> :
                  <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEditUsers ? "" : " disabled"}`} />
                }
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
}

